import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { ErrorService } from 'src/app/services/error.service';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment';
import * as ParcelActions from '../actions/parcel.actions';
import { AppState } from '../app.reducer';
import { state } from '@angular/animations';
import { TranslationService } from 'src/app/services/translation.service';



@Injectable()
export class ParcelEffects {
  constructor(
    public actions$: Actions,
    public http: HttpClient,
    private errorService: ErrorService,
    private store: Store<AppState>,
    private toastService: ToastService,
    private navController: NavController,
    private translationService: TranslationService
  ) { }
  payloadReload;

  //new
  getParcelById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParcelActions.getParcelById),
      switchMap((payload) => {
        ParcelActions.parcelLoading({ payload: { loading: true } });
        return this.http

          .get<any>(environment.apiUrl + '/parcels/' + payload.payload.id)
          .pipe(
            map((x) => {
              return x.data;
            }),
            switchMap((responseData) => {
              this.store.dispatch(
                ParcelActions.getParcelByIdSuccess({
                  payload: {
                    parcel: responseData,
                  },
                })
              );
              return of(
                ParcelActions.parcelLoading({ payload: { loading: false } })
              );
            }),
            catchError((error) => {
              this.store.dispatch(
                ParcelActions.parcelFail({
                  payload: { error: this.errorService.mapError(error) },
                })
              );
              return of(
                ParcelActions.parcelLoading({ payload: { loading: false } })
              );
            })
          );
      })
    )
  );


  createParcel$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ParcelActions.createParcel),
      switchMap((data) => {
        this.store.dispatch(ParcelActions.parcelLoading({ payload: { loading: true } }));
        return this.http
          .post<{ id: number }>(environment.apiUrl + '/parcels', data.payload)
          .pipe(
            tap((payload) => {
              this.navController.navigateBack('/parcels/' + payload.id);
              this.toastService.showToast(this.translationService.translate('STATUS_UPDATE.UPDATE'));
            }),
            map((payload) => ParcelActions.parcelCreated({ id: payload.id })),
            catchError((error) => {
              this.store.dispatch(ParcelActions.parcelLoading({ payload: { loading: false } }));
              return of(ParcelActions.parcelFail({
                payload: { error: this.errorService.mapError(error) },
              }));
            })
          );
      })
    );
  });

  updateParcel$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ParcelActions.editParcel),
      switchMap(({ payload }) => {
        this.store.dispatch(
          ParcelActions.parcelLoading({ payload: { loading: true } })
        );
        return this.http
          .put<null>(
            environment.apiUrl + `/parcels/${payload.parcel_spatial.id}`,
            payload
          )
          .pipe(
            switchMap(() => {
              if (localStorage.getItem('isEditModeE9Entos') !== 'true') {
                this.toastService.showToast(`${this.translationService.translate('STATUS_UPDATE.UPDATE')}`);
              }

              if (localStorage.getItem('isEditModeE9Ektos') !== 'true') {
                this.toastService.showToast(`${this.translationService.translate('STATUS_UPDATE.UPDATE')}`);
              }
              return of(
                ParcelActions.editParcelSuccess(),
                ParcelActions.parcelLoading({ payload: { loading: false } })//
              );
            }),
            catchError((error) => {
              // if (environment.production && payload.prop.date_retired != null) {
              //   const errorMessage = this.translationService.translate('API_ERRORS.RETIRED_BUILDING_CANNOT_UPDATE');
              //   return of(
              //     ParcelActions.parcelFail({
              //       payload: { error: { messageToUser: errorMessage } },
              //     })
              //   );
              // } else {
              return of(
                ParcelActions.parcelFail({
                  payload: { error: this.errorService.mapError(error) },
                })
              );
              // }
            })
          );
      })
    );
  });

  retiredOrReactivatedParcel$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ParcelActions.retiredOrReactivatedParcel),
      switchMap(({ payload }) => {
        this.store.dispatch(
          ParcelActions.parcelLoading({ payload: { loading: true } })
        );
        let retireOrReact: string;
        if (payload.retired) {
          retireOrReact = 'retire';
        }
        else {
          retireOrReact = 'reactivation';
        }
        return this.http
          .put<null>(
            environment.apiUrl + `/props/${retireOrReact}/${payload.kadik}`,
            payload
          )
          .pipe(
            switchMap(() => {
              return of(
                ParcelActions.retiredOrReactivatedParcelSuccess(),
                ParcelActions.parcelLoading({ payload: { loading: false } })
              );
            }),
            catchError((error) => {
              if (
                environment.optimisticLockErrors.includes(error.error?.name)
              ) {
                return of(
                  ParcelActions.parcelSelectOptimisticLockError({
                    payload: {
                      optimisticLockError: this.errorService.mapError(error),
                    },
                  })
                );
              } else
                return of(
                  ParcelActions.parcelFail({
                    payload: { error: this.errorService.mapError(error) },
                  })
                );
            })
          );
      })
    );
  });


  deleteParcel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParcelActions.deleteParcel),
      switchMap((payload) => {
        ParcelActions.parcelLoading({ payload: { loading: true } });
        return this.http
          .delete<any>(environment.apiUrl + '/parcels/' + payload.payload.id)
          .pipe(
            map((x) => {
              return x.data;
            }),
            switchMap((responseData) => {
              this.store.dispatch(
                ParcelActions.deleteParcelSuccess({
                  payload: {
                    parcel: responseData,
                  },
                })
              );
              this.toastService.showToast(`${this.translationService.translate('STATUS_UPDATE.DELETE')}`);
              return of(
                ParcelActions.parcelLoading({ payload: { loading: false } })
              );
            }),
            catchError((error) => {
              this.store.dispatch(ParcelActions.parcelLoading({ payload: { loading: false } }));
              return of(
                ParcelActions.parcelFail({
                  payload: { error: this.errorService.mapError(error) },
                })
              );
            })
          );
      })
    )
  );

  downloadFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParcelActions.downloadFile),
      switchMap((data) => {
        this.store.dispatch(
          ParcelActions.fileLoading({
            payload: { loading: true },
          })
        );
        return this.http.get(`${environment.apiUrl}/files/${data.payload.filename}`,
          {
            params: {
              filepath: data?.payload?.filepath?.toString(),
              filename: data?.payload?.filename?.toString()
            },
            responseType: 'blob',
          }
        )
          .pipe(
            switchMap((blob) => {
              this.store.dispatch(ParcelActions.downloadFileSuccess());
              // Open or Download the blob file
              const fileURL = window.URL.createObjectURL(blob);
              window.open(fileURL);
              this.toastService.showToast(`${this.translationService.translate('STATUS_UPDATE.DOWNLOAD')}`);
              return of(
                ParcelActions.fileLoading({
                  payload: { loading: false },
                })
              );
            }),
            catchError((error) => {
              // console.log(error);
              this.store.dispatch(
                ParcelActions.fileLoading({ payload: { loading: false } })
              );
              if (error.error instanceof Blob) {
                return of(
                  ParcelActions.fileErrorMsgFromBlobResponse({
                    payload: { errorMsgBlob: error.error },
                  })
                );
              } else {
                return of(
                  ParcelActions.fileFail({
                    payload: { fileError: this.errorService.mapError(error) },
                  })
                );
              }
            })
          );
      })
    )
  );


  getParcelsWithExpiringRights$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParcelActions.getParcelsWithExpiringRights),
      switchMap(action => {
        return this.http
          .get<any>(`${environment.apiUrl}/parcelsWithExpiring`, {
            params: {
              startDate: action.payload.startDate,
              endDate: action.payload.endDate
            }
          })
          .pipe(
            map(responseData => {
              return ParcelActions.getParcelsWithExpiringRightsSuccess({
                payload: { responseData }
              });
            }),
            catchError(error => {
              return of(ParcelActions.parcelFail({
                payload: { error: this.errorService.mapError(error) }
              }));
            }),
          );
      })
    )
  );


  getParcelsWithExpiringRightsCount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParcelActions.getParcelsWithExpiringRightsCount),
      switchMap(() => {
        return this.http
          .get<{ right_type: string; count: string }[]>(
            `${environment.apiUrl}/expiring-rights`
          )
          .pipe(
            map((response) => {
              if (response && Array.isArray(response)) {
                const formattedData = response.map((item) => ({
                  ...item,
                  count: parseInt(item.count, 10), // Ensure count is a number
                }));
                return ParcelActions.getParcelsWithExpiringRightsCountSuccess({
                  payload: formattedData,
                });
              } else {
                throw new Error('Invalid response structure');
              }
            }),
            catchError((error) => {
              console.error('Error fetching parcels with expiring rights count:', error);
              return of(
                ParcelActions.parcelFail({
                  payload: { error: this.errorService.mapError(error) },
              }));
            }),
          );
      })
    )
  );
}
